<template>
  <v-container class="pa-0" fluid v-resize="resizeTable">
    <v-card flat>
      <v-flex>
        <v-card-text>
          <v-data-table
            :mobile-breakpoint="0"
            :headers="headers.map((item) => ({ ...item, text: $t(item.text) }))"
            fixed-header
            :items="editedOrganization.settings.tags"
            item-key="id"
            :options.sync="pagination"
          >
            <template v-slot:item.name="{ value }">
              <span>{{ value }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <gli-editor-button
                    class="ml-2"
                    color="primary"
                    fab
                    x-small
                    dark
                    v-on="on"
                    @click="editTag(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </gli-editor-button>
                </template>
                <span>{{ $t('Edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <gli-editor-button
                    class="ml-2"
                    color="error"
                    fab
                    x-small
                    dark
                    v-on="on"
                    @click="deleteTag(item.id)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </gli-editor-button>
                </template>
                <span>{{ $t('Delete') }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-flex>

      <v-card-actions class="mr-2">
        <v-spacer></v-spacer>
        <gli-editor-button small color="primary" @click="addNewTag">{{
          $t('New tag')
        }}</gli-editor-button>
      </v-card-actions>
    </v-card>

    <tag-dialog v-if="editedTag"></tag-dialog>
  </v-container>
</template>

<style lang="scss" scoped></style>
<script>
import TagDialog from './TagDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import resizeTable from '../mixins/resizeTable';

export default {
  name: 'Tags',
  props: [],

  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Extrusion base',
          value: 'base'
        },
        {
          text: 'Extrusion top',
          value: 'top'
        },
        {
          text: '',
          value: 'actions',
          width: 232,
          sortable: false,
          align: 'end'
        }
      ],
      pagination: {
        page: 1
      }
    };
  },

  computed: {
    ...mapGetters('organization', ['editedOrganization', 'editedTag'])
  },

  mounted() {},
  methods: {
    ...mapActions('organization', ['addNewTag', 'editTag', 'deleteTag'])
  },
  mixins: [resizeTable],
  components: { TagDialog }
};
</script>
